var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { growWrapperStyle, fauxGrowElementStyle } from './styles';
// Add space at the end of faux element content to prevent jumping
function AutoGrow(_a) {
    var value = _a.value, size = _a.size, autoGrow = _a.autoGrow, children = _a.children;
    return autoGrow ? (_jsxs("div", __assign({ css: growWrapperStyle() }, { children: [children, _jsx("div", __assign({ "aria-hidden": "true", css: fauxGrowElementStyle({ size: size }) }, { children: "".concat(value, " ") }))] }))) : (children);
}
export default AutoGrow;
